import { render, staticRenderFns } from "./PersonName.vue?vue&type=template&id=006b9866&"
import script from "./PersonName.vue?vue&type=script&lang=js&"
export * from "./PersonName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports